<template>
  <div class="flex flex-column">
    <component :is="linkComponent" :to="{ name: cardLink, params: { id: itemContext.parentId } }" class="link">
      <div v-if="itemContext.showTitle" class="journal-full-item-layout">
        <div class="journal-full-item-status text-primary" id="journal-full-item-status">{{ statusTitle(item.newStatus) }}</div>
        <div class="journal-full-item-ago text-secondary f6" id="journal-full-item-ago">{{ timeAgo(item.insertedAt) }}</div>
        <div class="journal-full-item-title text-primary lh-copy" id="journal-full-item-title">{{ title }}</div>
        <div class="journal-full-item-user text-secondary f6" id="journal-full-item-user">{{ item.userName }}</div>
      </div>
      <div v-else class="journal-item-layout">
        <div class="journal-item-status text-primary" id="journal-item-status">{{ statusTitle(item.newStatus) }}</div>
        <div class="journal-item-time text-secondary f6" id="journal-item-time">{{ formatDate() }}</div>
        <div class="journal-item-ago text-secondary f6" id="journal-item-ago">{{ timeAgo(item.insertedAt) }}</div>
        <div class="journal-item-user text-primary" id="journal-item-user">{{ item.userName }}</div>
        <div class="journal-item-company text-secondary f6" id="journal-item-company">{{ item.companyTitle }}</div>
      </div>
    </component>
  </div>
</template>

<script>
const moment = require('moment')

export default {
  props: ['itemContext'],
  computed: {
    item () {
      return this.itemContext.item
    },
    cardLink () {
      return this.itemContext.cardLink
    },
    linkComponent () {
      return this.itemContext.cardLink ? 'router-link' : 'div'
    },
    title () {
      return this.itemContext.parentTitle
    }
  },
  methods: {
    formatDate () {
      return moment(this.item.insertedAt).format('YYYY-MM-DD HH:mm')
    },
    timeAgo (datetime) {
      return moment(datetime).fromNow()
    },
    statusTitle (statusCode) {
      return statusCode ? this.itemContext.statusByCode(statusCode).title : null
    }
  }
}
</script>

<style lang="scss" scoped>
.journal-full-item-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "status title"
    "ago    user";
  grid-column-gap: .25rem;
  grid-row-gap: .25rem;
}
.journal-full-item-status {
  grid-area: status;
}
.journal-full-item-title {
  grid-area: title;
}
.journal-full-item-time {
  grid-area: time;
  margin-top: .1rem;
}
.journal-full-item-ago {
  grid-area: ago;
}
.journal-full-item-user {
  grid-area: user;
  justify-self: start;
}
.journal-full-item-company {
  grid-area: company;
  justify-self: start;
}
.journal-item-layout {
  display: grid;
  grid-template-columns: 150px 1fr 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "time status user"
    "time ago    company";
  grid-column-gap: .25rem;
  grid-row-gap: .25rem;
}
.journal-item-status {
  grid-area: status;
}
.journal-item-time {
  grid-area: time;
  margin-top: .1rem;
}
.journal-item-ago {
  grid-area: ago;
}
.journal-item-user {
  grid-area: user;
  justify-self: end;
}
.journal-item-company {
  grid-area: company;
  justify-self: end;
}
</style>
